module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eqZrb"))).then(() => parcelRequire('hEqeo'));